import {cgUserHttp} from './index'

function cgUserRequest(url, method, data) {
    return cgUserHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return cgUserRequest(url, 'get', data)
}

function post(url, data) {
    return cgUserRequest(url, 'post', data)
}

export function cgShopItemStock() {
    return get('/shopping/current/stock')
}

export function searchUser(data) {
    return post('/cat/admin/search',data)
}

export function searchOrder(data) {
    return post('/shopping/admin/record',data)
}
